// extracted by mini-css-extract-plugin
export default {"root":"Results_root__Es-VW"};